import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import { fetchAgentStatistics } from "../../../store/slices/UpworkSlice";
import Loading from "../../../hooks/utils/Loading/Loading";
import Error404 from "../../../hooks/utils/Error/Error";
import Breadcrumbs from "../../../components/Breadcrumbs";

const AgentStatistics = () => {
  const dispatch = useDispatch();
  const { agentStatistics, status, error } = useSelector(
    (state) => state?.upwork || {}
  );
  const upworkRole = useSelector(
    (state) => state?.user?.userDetails?.data?.user?.upworkRole
  );
  const [filter, setFilter] = useState({
    statFrom: '',
    statTo: '',
  });

  function handleFilter(key, value) {
    setFilter(prev => {
      return {
        ...prev,
        [key]: value
      }
    });
  }

  useEffect(() => {
    const date = {
      ...(filter.statFrom && { gte: filter.statFrom }),
      ...(filter.statTo && { lte: filter.statTo }),
    };
    dispatch(fetchAgentStatistics({ filter: { date: date } }));
  }, [dispatch, filter]);

  // Generate columns based on user role
  const getColumns = () => { 
    const baseColumns = [
      { title: "#", dataIndex: "id", width: "5%" },
      { title: "Customer Support Officer Name", dataIndex: "agentName", width: "20%" },
      { title: "Total Projects", dataIndex: "projects", width: "15%" },
      { title: "Ongoing Projects", dataIndex: "ongoingProjects", width: "15%" },
      { title: "Completed Projects", dataIndex: "completedProjects", width: "15%" },
      { title: "Total Working Hours", dataIndex: "totalWorkingHours", width: "15%" },
      { title: "Average Working Hours", dataIndex: "averageWorkingHours", width: "15%"}
    ];
    
    // These columns are only visible to managers
    if (upworkRole === "manager") {
      baseColumns.push(
        { title: "Ongoing Earnings", dataIndex: "ongoingEarnings", width: "15%" },
        { title: "Total Earnings", dataIndex: "totalEarnings", width: "15%" },
      );
    }

    return baseColumns;
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Customer Support Officer Statistics"
            title="Dashboard"
            subtitle="Statistics"
          />
          <div className="row">
            <div className="col-md-3">
              <div className="input-block mb-3">
              <label className="col-form-label">Start Date</label>
                <input
                  className="form-control floating datetimepicker"
                  type="date"
                  value={
                    filter?.statFrom
                      ? new Date(filter?.statFrom)
                        .toISOString()
                        .split("T")[0]
                      : ""
                  }
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => handleFilter('statFrom', e.target.value)}
                  placeholder="Start Date"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="input-block mb-3">
              <label className="col-form-label">End Date</label>
                <input
                  className="form-control floating datetimepicker"
                  type="date"
                  value={
                    filter?.statTo
                      ? new Date(filter?.statTo)
                        .toISOString()
                        .split("T")[0]
                      : ""
                  }
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) => handleFilter('statTo', e.target.value)}
                  placeholder="End date"
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="table-responsive">
                <Table
                  columns={getColumns()}
                  dataSource={prepareStatisticsForDisplay(agentStatistics)}
                  className="table-striped"
                  rowKey={(record) => record.agentName}
                  locale={getTableLocale(status, error)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentStatistics;

// Helper to format statistics for display
const prepareStatisticsForDisplay = (statistics) => {
  return statistics.map((stat, index) => ({
    key: index,
    id: index + 1,
    ...stat,
  }));
};

// Utility for table locale (loading, errors, empty)
const getTableLocale = (status, error) => {
  return {
    emptyText: status?.fetchAgentStatistics === "loading" ? (
      <Loading />
    ) : error?.fetchAgentStatistics ? (
      <div className="text-center text-danger">
        <Error404 />
      </div>
    ) : (
      "No Data"
    ),
  };
};
